import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../../utils';

export interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-3',
};

export const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(
  ({ size = 'md', className, ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      aria-label="Loading"
      className={cn(
        // agn-spinner is an inert hook: next-components.css (next scope only)
        // paints the ring with semantic tokens.
        'agn-spinner animate-spin rounded-full border-border-hover border-t-[var(--action-primary)]',
        sizeClasses[size],
        className
      )}
      {...props}
    />
  )
);
Spinner.displayName = 'Spinner';
